var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',{staticClass:"nav-toc__toggle styled-button",class:{
    'nav-toc__toggle--is-expanded': _vm.internalIsExpanded,
    'nav-toc__toggle--no-text': !_vm.hasButtonText,
    'nav-toc__toggle--has-heading': _vm.hasHeadingSize,
    'is-closing': _vm.isClosing,
  },attrs:{"aria-expanded":_vm.isExpanded ? 'true' : 'false'},on:{"click":_vm.toggle}},[_c('div',[_c('span',{staticClass:"nav-toc__icon",class:{
        'nav-toc__icon--close': _vm.isExpanded,
        'nav-toc__icon--open': !_vm.isExpanded,
      }},[_c('a-label',{attrs:{"path":_vm.isExpanded ? 'dossier.close' : 'dossier.open'}})],1)]),_vm._v(" "),(_vm.hasButtonText)?_c('strong',{staticClass:"nav-toc__toggle-text",class:{
      'nav-toc__heading': _vm.hasHeadingSize,
    },attrs:{"id":"nav-toc"}},[_vm._v(_vm._s(_vm.buttonText))]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }